<template>
  <v-navigation-drawer app v-model="drawer" style="height: 100%">
    <v-list dense class="py-0">
      <v-list-item two-line class="px-2">
        <v-list-item-avatar>
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ fullName }}</v-list-item-title>
          <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="px-2">
        <v-list-item-content>
          <v-select
            @change="onDistrictChange"
            v-model="districtId"
            :items="districts"
            outlined
            dense
            label="Distrikt"
            item-text="districtName"
            item-value="districtId"
          ></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-item-group active-class="primary--text text--accent-4">
        <v-subheader>ARBETE</v-subheader>
        <v-list-item to="/schema">
          <v-list-item-title>Schema</v-list-item-title>
        </v-list-item>
        <v-list-item :to="workdayPath">
          <v-list-item-title>Arbetsdag</v-list-item-title>
        </v-list-item>
        <v-list-item to="/crew">
          <v-list-item-title>Tågsök</v-list-item-title>
        </v-list-item>

        <v-divider />
        <v-subheader>FORDON</v-subheader>
        <v-list-item to="/circulations">
          <v-list-item-title>Omlopp</v-list-item-title>
        </v-list-item>
        <v-list-item to="/train-reversals">
          <v-list-item-title>Tågvändningar</v-list-item-title>
        </v-list-item>

        <v-divider />
        <v-subheader>ERSÄTTNINGSTRAFIK</v-subheader>
        <v-list-item to="/">
          <v-list-item-title>Översikt</v-list-item-title>
        </v-list-item>
        <v-list-item to="/stops">
          <v-list-item-title>Hållplats</v-list-item-title>
        </v-list-item>
        <v-divider />
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <v-btn block tile @click="onLogout">
        <v-icon small left>mdi-exit-to-app</v-icon>
        Logga ut
      </v-btn>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { format } from 'date-fns'
import { sync, get } from 'vuex-pathify'

export default {
  name: 'AppNavigationDrawer',

  data() {
    return {
      districtId: null
    }
  },

  created() {
    this.districtId = this.$store.get('sso/districtId')
  },

  computed: {
    drawer: sync('app/drawer'),
    districts: get('sso/districts'),

    workdayPath() {
      return `/workday/${format(new Date(), 'yyyy-MM-dd')}/${
        this.$store.get('sso/user').employeenumber
      }`
    },

    fullName() {
      const { firstname, lastname } = this.$store.state.sso.user
      return `${firstname} ${lastname}`
    },

    email() {
      const { mail } = this.$store.state.sso.user
      return mail
    }
  },

  methods: {
    onDistrictChange(value) {
      this.$store.commit('sso/SET_DEFAULT_DISTRICT', value)
      window.location.reload()
    },

    onLogout() {
      this.$sso.logout()
    }
  }
}
</script>
